import { FC, Fragment, useCallback } from 'react';
// i18next
import { useTranslation } from 'react-i18next';
// Types
import QuizTypes from 'types/QuizTypes';
import Interactions from 'types/Interactions';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
// Async
import { createAnalyticsInteract } from 'store/player/playerAsync';
// Selectors
import { selectQuiz } from 'store/quiz/quizSelectors';
import { selectResultId } from 'store/auth/authSelectors';

const ProceedData:FC = () => {
  const { t } = useTranslation();
  // Dispatch
  const dispatch = useAppDispatch();
  // State
  const quiz:any = useAppSelector(selectQuiz);
  const resultId = useAppSelector(selectResultId);

  const isTeamSelectorQuiz = quiz.type === QuizTypes.TeamSelector;

  const handleProceedClick = useCallback((interaction:Interactions) => {
    if (!resultId) return;
    dispatch(createAnalyticsInteract({
      result: resultId,
      name: interaction
    }));
    // eslint-disable-next-line
  }, [resultId]);

  if ( [QuizTypes.Personality, QuizTypes.Poll, QuizTypes.Survey, QuizTypes.RankingPoll].includes(quiz.type) ) return null;
  if ( !quiz.callToAction.enabled ) return null;
  return (
    <Fragment>
      {quiz.callToAction.title ? (
        <h3 className="text-center text-3xl text-primary font-bold px-4 mb-6">
          {quiz.callToAction.title}
        </h3>
      ) : null}
      {quiz.callToAction.clickBonusPoints && !isTeamSelectorQuiz ? (
        <h3 className="text-center text-xl text-primary font-bold px-4 mb-6">
          {t('pages.postQuiz.title', { points: quiz.callToAction.clickBonusPoints })}
        </h3>
      ) : null}
      {quiz.callToAction.image ? (
        <a
          className="block rounded mb-4 overflow-hidden border border-white"
          href={quiz.callToAction.url || undefined}
          target="_blank"
          rel="noreferrer"
          onClick={() => handleProceedClick(Interactions.CtaUrlClick)}
        ><img src={quiz.callToAction.image} alt={quiz.callToAction.text || `${t('buttons.visit')} ${quiz.namespace}`} /></a>
      ) : null}

      {quiz.callToAction.url ? (
        <div className="text-center">
          <a
            className="
              py-2 px-4
              inline-block rounded-2xl
              font-semibold primary-button
            "
            href={quiz.callToAction.url}
            target="_blank"
            rel="noreferrer"
            onClick={() => handleProceedClick(Interactions.CtaUrlClick)}
          >{quiz.callToAction.text || `${t('buttons.visit')} ${quiz.namespace}`}</a>
        </div>
      ) : null}

      {quiz.callToAction.url2 ? (
        <div className="text-center">
          <a
            className="
              mt-4
              py-2 px-4
              inline-block rounded-2xl
              font-semibold primary-button
            "
            href={quiz.callToAction.url2}
            target="_blank"
            rel="noreferrer"
            onClick={() => handleProceedClick(Interactions.CtaUrl2Click)}
          >{quiz.callToAction.text2 || `${t('buttons.visit')} ${quiz.namespace}`}</a>
        </div>
      ) : null}
    </Fragment>
  )
}

export default ProceedData;
